hmi.utils.resize_component = function () {
  var selector = null,
    data = null,
    SIZE_RECT = 10,
    MARGIN_SIZE = -5,
    widthComponent = 75,
    heightComponent = 75,
    widthMaxComponent = 150,
    heightMaxComponent = 150,
    MIN_VALUE = 75,
    notResize = false;

  var dispatch = d3.dispatch("finish_resize");

  var dragStartCallBack, dragCallBack, dragEndCallBack;

  var dragBehavior = d3.behavior
    .drag()
    .on("dragstart", function (d) {
      d3.event.sourceEvent.stopPropagation();
      if (dragStartCallBack) {
        dragStartCallBack(d);
      }
    })
    .on("drag", function (d, i) {
      var x = d.x;
      var y = d.y;
      var position = parseInt(d3.select(this).attr("position"));
      switch (position) {
        case hmi.constant.resizeRect.leftTop:
          d.x = d.x + d3.event.x;
          d.y = d.y + d3.event.y;
          d.width = d.width + (x - d.x);
          d.height = d.height + (y - d.y);
          if (d.width < widthComponent || d.width > widthMaxComponent) {
            d.x = x;
          }
          if (d.height < heightComponent || d.height > heightMaxComponent) {
            d.y = y;
          }
          break;
        case hmi.constant.resizeRect.leftBottom:
          d.x = d.x + d3.event.x;
          d.width = d.width + (x - d.x);
          d.height = d.width;
          if (d.width < widthComponent || d.width > widthMaxComponent) {
            d.x = x;
          }
          break;
        case hmi.constant.resizeRect.rigthTop:
          d.y += d3.event.y;
          d.height = d.width + (y - d.y);
          d.width = d.height;
          if (d.height < heightComponent || d.height > heightMaxComponent) {
            d.y = y;
          }
          break;
        case hmi.constant.resizeRect.rigthBottom:
          var value = Math.max(d3.event.x, d3.event.y);
          d.width = value;
          d.height = value;
          break;
      }

      d.width = Math.max(Math.min(d.width, widthMaxComponent), widthComponent);

      d.height = Math.max(
        Math.min(d.height, heightMaxComponent),
        heightComponent
      );
      var sele = selector;
      d3.select(selector.parentNode).attr(
        "transform",
        "translate(" + d.x + "," + d.y + ")"
      );
      d3.select(selector).select("svg").attr({
        width: d.width,
        height: d.height
      });
      update_rect();
      if (dragCallBack) {
        dragCallBack(d);
      }
    })
    .on("dragend", function (d) {
      dispatch.finish_resize({
        linkId: d.id,
        width: d.width,
        height: d.height,
        positionPipe: d.positionPipe,
        x: d.x,
        y: d.y
      });
      if (dragEndCallBack) {
        dragEndCallBack(d);
      }
    });
  var update_rect = function (d) {
    var contentBox = d3.select(selector).node().getBBox();
    d3.select("g.resize-box > rect").attr({
      x: contentBox.x,
      y: contentBox.y,
      width: parseInt(contentBox.width),
      height: parseInt(contentBox.height)
    });

    d3.select("g.move-rect > rect.move-rect-left-top").attr({
      x: MARGIN_SIZE + contentBox.x,
      y: MARGIN_SIZE + contentBox.y
    });
    d3.select("g.move-rect > rect.move-rect-left-bottom").attr({
      x: MARGIN_SIZE + contentBox.x,
      y: contentBox.height + MARGIN_SIZE + contentBox.y
    });
    d3.select("g.move-rect > rect.move-rect-rigth-top").attr({
      x: contentBox.width + MARGIN_SIZE + contentBox.x,
      y: contentBox.height + MARGIN_SIZE + contentBox.y
    });
    d3.select("g.move-rect > rect.move-rect-rigth-bottom").attr({
      x: contentBox.width + MARGIN_SIZE + contentBox.x,
      y: MARGIN_SIZE + contentBox.y
    });
  };

  function resize_component() {
    d3.select("g.resize-box").remove();
    if (selector && hmi.showMode === hmi.constant.showMode.design) {
      var contentBox = d3.select(selector).node().getBBox();
      var select = d3.select(selector.parentNode);
      var selectEnter = select.append("g").classed("resize-box", true);

      selectEnter
        .append("rect")
        .attr("x", contentBox.x)
        .attr("y", contentBox.y)
        .attr("width", parseInt(contentBox.width))
        .attr("height", parseInt(contentBox.height));
      if (!notResize) {
        var gRect = selectEnter.append("g").classed("move-rect", true);

        gRect
          .append("rect")
          .classed("move-rect-left-top", true)
          .attr({
            x: MARGIN_SIZE + contentBox.x,
            y: MARGIN_SIZE + contentBox.y,
            width: SIZE_RECT,
            height: SIZE_RECT,
            position: hmi.constant.resizeRect.leftTop
          })
          .call(dragBehavior);

        gRect
          .append("rect")
          .classed("move-rect-left-bottom", true)
          .attr({
            x: MARGIN_SIZE + contentBox.x,
            y: contentBox.height + MARGIN_SIZE + contentBox.y,
            width: SIZE_RECT,
            height: SIZE_RECT,
            position: hmi.constant.resizeRect.leftBottom
          })
          .call(dragBehavior);

        gRect
          .append("rect")
          .classed("move-rect-rigth-top", true)
          .attr({
            x: contentBox.width + MARGIN_SIZE + contentBox.x,
            y: contentBox.height + MARGIN_SIZE + contentBox.y,
            width: SIZE_RECT,
            height: SIZE_RECT,
            position: hmi.constant.resizeRect.rigthBottom
          })
          .call(dragBehavior);
        gRect
          .append("rect")
          .classed("move-rect-rigth-bottom", true)
          .attr({
            x: contentBox.width + MARGIN_SIZE + contentBox.x,
            y: MARGIN_SIZE + contentBox.y,
            width: SIZE_RECT,
            height: SIZE_RECT,
            position: hmi.constant.resizeRect.rigthTop
          })
          .call(dragBehavior);
      }
    }
  }

  resize_component.dispatch = dispatch;
  resize_component.options = hmi.utils.optionsFunc.bind(resize_component);

  resize_component.clean = function () {
    d3.select("g.resize-box").remove();
    selector = null;
    if (data) {
      data.select = false;
    }
    data = null;
  };

  resize_component._options = Object.create(
    {},
    {
      // simple read/write options
      data: {
        get: function () {
          return data;
        },
        set: function (_) {
          data = _;
        }
      },
      widthComponent: {
        get: function () {
          return widthComponent;
        },
        set: function (_) {
          widthComponent = _;
        }
      },
      heightComponent: {
        get: function () {
          return heightComponent;
        },
        set: function (_) {
          heightComponent = _;
        }
      },
      widthMaxComponent: {
        get: function () {
          return widthMaxComponent;
        },
        set: function (_) {
          widthMaxComponent = _;
        }
      },
      heightMaxComponent: {
        get: function () {
          return heightMaxComponent;
        },
        set: function (_) {
          heightMaxComponent = _;
        }
      },
      notResize: {
        get: function () {
          return notResize;
        },
        set: function (_) {
          notResize = _;
        }
      },
      selector: {
        get: function () {
          return selector;
        },
        set: function (_) {
          selector = _;
          resize_component();
        }
      },
      dragStartCallBack: {
        get: function () {
          return dragStartCallBack;
        },
        set: function (_) {
          dragStartCallBack = _;
        }
      },
      dragCallBack: {
        get: function () {
          return dragCallBack;
        },
        set: function (_) {
          dragCallBack = _;
        }
      },
      dragEndCallBack: {
        get: function () {
          return dragEndCallBack;
        },
        set: function (_) {
          dragEndCallBack = _;
        }
      }
    }
  );

  hmi.utils.initOptions(resize_component);

  return resize_component;
};
